// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Avatar_avatar__2I04Q","avatarRoot":"Avatar_avatarRoot__uYr6l"};